module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@1.2.7@core-js/library/modules/$.library.js
// module id = 72
// module chunks = 0